<div class="po-type-form">
    <h6 class="form-section-title">Work Order</h6>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="ewoEmCo">EM Co</label>
            <input type="number" class="form-control" [(ngModel)]="item().emCo" name="ewoEmCo" id="ewoEmCo" />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="ewoWo">WO</label>
            <input type="text" class="form-control" [(ngModel)]="item().workOrder" name="ewoWo" id="ewoWo" />
        </div>
        <div class="col-sm-5 col-12 form-group">
            <label for="ewoWoDesc">WO Description</label>
            <input type="text" class="form-control-plaintext" [value]="item().workOrderDescription" id="ewoWoDesc" readonly />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="ewoWoItem">WO Item</label>
            <input type="number" class="form-control" [(ngModel)]="item().woItem" name="ewoWoItem" id="ewoWoItem" />
        </div>
    </div>

    <h6 class="form-section-title mt-3">Cost</h6>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="ewoCostCode">Cost Code</label>
            <input type="text" class="form-control" [(ngModel)]="item().costCode" name="ewoCostCode" id="ewoCostCode" readonly />
        </div>
        <div class="col-sm-3 col-6 form-group">
            <label for="ewoCostType">CT</label>
            <input type="number" class="form-control" [(ngModel)]="item().costType" name="ewoCostType" id="ewoCostType" />
        </div>
    </div>

    <h6 class="form-section-title mt-3">Equipment</h6>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="ewoEquipment">Equipment</label>
            <input type="text" class="form-control-plaintext" [value]="item().equipment" id="ewoEquipment" readonly />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="ewoComponent">Component</label>
            <input type="text" class="form-control" [(ngModel)]="item().component" name="ewoComponent" id="ewoComponent" />
        </div>
    </div>

    <app-po-common-fields [item]="item()" [glAccountReadonly]="true"></app-po-common-fields>
</div>
